<template>
  <form autocomplete="false" v-on:submit.prevent>
    <vue-form-generator :schema="schema" :model="datas" :options="formOptions"></vue-form-generator>
  </form>
</template>

<script>
import { getUsers, addUsers, updateUsers, deleteUsers } from '@/api/crm-api.js'

export default {
  props: {
    id: String
  },
  data () {
    return {
      datas: {},
      schema: {
        groups: [
          {
            legend: 'Utilisateurs',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                label: 'Login',
                model: 'login',
                placeholder: 'Login'
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Nom',
                model: 'nom',
                placeholder: 'Nom'
              },
              {
                type: 'select',
                model: 'profile',
                label: 'Profile',
                selectOptions: { noneSelectedText: 'Veuillez selectionner un profile' },
                values: ["admin","vendeur"]
              },
              {
                type: 'input',
                inputType: 'text',
                label: 'Mot de passe',
                model: 'password',
                placeholder: 'Laisser vide pour ne pas le changer'
              }
            ]
          },
          {
            legend: '',
            fields: [
              {
                type: 'submit',
                buttonText: 'Ajouter',
                onSubmit: this.add,
                styleClasses:'col-auto p-0 float-right',
                validateBeforeSubmit: true,
                visible (status) {
                    return status != null && status.id == null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Sauver',
                validateBeforeSubmit: true,
                onSubmit: this.update,
                styleClasses:'col-auto p-0 float-right',
                visible (status) {
                    return status != null && status.id != null;
                }
              },
              {
                type: 'submit',
                buttonText: 'Supprimer',
                validateBeforeSubmit: false,
                onSubmit: this.delete,
                styleClasses:'col-auto float-left p-0',
                visible (status) {
                    return status != null && status.id != null;
                }
              }
            ]
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },
  methods: {
    add () {
      addUsers(this.datas).then((response) => {
        this.$router.push({name:'usersManager', params:{ id: response.data.id }}).catch(() => {})
        this.$store.commit('addMessage',{text:'L\'utilisateur ' + this.datas.login + ' à été crée', status:'success'})
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    update () {
      updateUsers(this.id,this.datas).then(() => {
        this.$store.commit('addMessage',{text:'L\'utilisateur ' + this.datas.login + ' à été mis à jour', status:'success'})
        this.$emit('onUpdate')
      })
      .catch((error) => {
        this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
      })
    },
    delete () {
      if (confirm('Etes vous sur de vouloir supprimer l\'utilisateur ' + this.datas.login)){
        deleteUsers(this.id).then(() => {
          this.$emit('onDelete')
          this.$store.commit('addMessage',{text:'Le statut à été supprimé', status:'success'})
        })
        .catch((error) => {
          this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
        })
      }
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: function () {
        if(this.id != null) {
          getUsers(this.id)
          .then((response) => {
            this.datas = response.data
          })
          .catch((error) => {
            this.$store.commit('addMessage',{text:'Une erreur est survenue '+error.toString(), status:'danger'})
          })
        } else {
          this.datas = {}
        }
      }
    }
  },
}
</script>

<style>

</style>
